/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../../api";
import * as common from "../../data/bff/common";
import * as creator_profile from "../../data/bff/creator_profile";
import * as plan from "../../data/bff/plan";
import * as product from "../../data/bff/product";
import * as sample_request from "../../data/bff/sample_request";
import * as homepage from "../../data/bff/homepage";
import * as notification from "../../data/bff/notification";
import * as article from "../../data/bff/article";
import * as product_selection from "../../data/bff/partner/product_selection";
import * as invitation from "../../data/bff/invitation";
export { api, common, creator_profile, plan, product, sample_request, homepage, notification, article, product_selection, invitation };
import { method, headers, queryStringify } from "../../../_util";
export var AffiliateBffApi = /*#__PURE__*/function () {
  function AffiliateBffApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateBffApi.prototype;
  _proto.GetHomepageData = function GetHomepageData(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/homepage" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetMainMenu = function GetMainMenu(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/menu" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetHomeBanner = function GetHomeBanner(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/banner";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetConfig = function GetConfig(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/config" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetAnnouncementList = function GetAnnouncementList(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/announcement/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetAnnouncement = function GetAnnouncement(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/announcement/detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ReadAnnouncement = function ReadAnnouncement(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/announcement/read";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCreatorsIMProfile = function GetCreatorsIMProfile(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/creator/profile";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListTargetPlanCreator = function ListTargetPlanCreator(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/creator/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.SearchCreatorTargetPlan = function SearchCreatorTargetPlan(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/target_plan/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorTargetPlan = function GetCreatorTargetPlan(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/target_plan/detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCTargetPlan = function GetCTargetPlan(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/target_plan/c_detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorSampleInfo = function GetCreatorSampleInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/sample/info" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.CreatorSampleApplyAction = function CreatorSampleApplyAction(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/sample/apply";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListProductPlanInfo = function ListProductPlanInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/product/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetPlanProductInfo = function GetPlanProductInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/product/detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCPlanProductInfo = function GetCPlanProductInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/plan/product/c_detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetIMUnreadMessageCount = function GetIMUnreadMessageCount(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/notification/im/unread_count";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetIMLatestMessage = function GetIMLatestMessage(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/notification/im/latest";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetIMUnreadMessage = function GetIMUnreadMessage(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/notification/im/unread" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListCategoryChildren = function ListCategoryChildren(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/product/category/children" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListCategoryChildrenV2 = function ListCategoryChildrenV2(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/product/category/childrenv2";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetIMMessage = function GetIMMessage(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/notification/im/message";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCCreatorSampleInfo = function GetCCreatorSampleInfo(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/sample/c_info" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetGuideArticle = function GetGuideArticle(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/article" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GenerateScreenshot = function GenerateScreenshot(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/screenshot";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetScreenshotTaskStatus = function GetScreenshotTaskStatus(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/screenshot/status" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetPartnerProductRankingEntry = function GetPartnerProductRankingEntry(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/partner/product/ranking/entry" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetPartnerProductRankingTab = function GetPartnerProductRankingTab(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/partner/product/ranking/tab";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetPartnerProductFilter = function GetPartnerProductFilter(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/partner/product/filter" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetFeelGoodToken = function GetFeelGoodToken(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/feelgood/token" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCFeelGoodToken = function GetCFeelGoodToken(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/feelgood/c_token" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetAuthCreatorsIMProfile = function GetAuthCreatorsIMProfile(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/creator/auth_profiles";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetImageXToken = function GetImageXToken(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/image/upload_token";
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.ListImageUrl = function ListImageUrl(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/image/url";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListCImageUrl = function ListCImageUrl(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/image/c_url";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCreatorInvitationDetail = function GetCreatorInvitationDetail(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/invitation/detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCreatorInvitationDetailToC = function GetCreatorInvitationDetailToC(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/invitation/c_detail" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetAvailableCreatorInvitationGroupList = function GetAvailableCreatorInvitationGroupList(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/invitation/available_list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetIMCreatorListOfInvitationGroup = function GetIMCreatorListOfInvitationGroup(request, option) {
    var query = queryStringify(request);
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/invitation/creator/list" + query;
    return ferryFetch(uri, {
      method: method,
      headers: headers
    }, option);
  };
  _proto.GetCProductDetailInfoList = function GetCProductDetailInfoList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/affiliate/lux/product/c_detail_list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return AffiliateBffApi;
}();
export var affiliateBffApiClient = new AffiliateBffApi();